import {
	Avatar,
	Checkbox,
	Chip,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Typography,
	useTheme,
} from '@mui/material';
import stylesLogo from '../Accounts/Account.styles';
import { capitalize } from '../../hepler/functions';
import sizeFontCustom from './fontSize.styles';
import { useTranslation } from '../../hooks/useTranslation';
import { toast } from 'react-toastify';

function FipDiscoveredAccounts(props) {
	const { t } = useTranslation();
	const theme = useTheme();
	const {
		account,
		handleCheckedState,
		selectedAccounts,
		fipId,
		isLinked,
		isVerified,
		customDetails,
	} = props;
	// Check for dark theme
	const isDark =
		customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	const handleClick = (event) => {
		// Check if account is already linked or just verified (linked in this session)
		const isAccountLinkedOrVerified =
			isLinked || isVerified?.includes(account.accRefNumber);

		if (
			!isAccountLinkedOrVerified &&
			account?.restrictions?.isMandatory.toLowerCase() === 'true'
		) {
			event.preventDefault();
			toast.error(t('accountDiscovery.errors.unselectMandatoryAccounts'));
			return;
		}
		if (
			!selectedAccounts.some((acc) => acc.accRefNumber === account.accRefNumber)
		) {
			event.target.checked = true;
		} else {
			event.target.checked = false;
		}
		handleCheckedState(event, account);
	};
	return (
		<ListItem
			onClick={handleClick}
			key={account.accRefNumber}
			sx={{ ml: '0.75rem', maxWidth: '95%' }}
			disablePadding
		>
			<ListItemIcon sx={{ minWidth: 0, mr: '0.25rem' }}>
				{!(
					isLinked ||
					isVerified?.includes(account.accRefNumber) ||
					isVerified?.length > 0
				) && (
					<Checkbox
						sx={{
							padding: 0,
							color: isDark ? '#7A8185' : '#D8E1EE',
							'&.Mui-checked': {
								color: customDetails?.primaryColor || '#3053D3',
							},
							'&:hover': {
								backgroundColor: isDark
									? 'rgba(255,255,255,0.1)'
									: 'rgba(0,0,0,0.04)',
							},
							'&.Mui-disabled': {
								color: isDark ? '#4A4A4A' : '#BDBDBD',
								'&.Mui-checked': {
									color: isDark ? '#4A4A4A' : '#BDBDBD',
								},
							},
						}}
						size="small"
						key={Math.random()}
						disabled={
							account?.restrictions?.isMandatory?.toLowerCase() === 'true'
						}
						// onChange={(event) => handleCheckedState(event, account)}
						name={account.accRefNumber}
						checked={
							selectedAccounts.some(
								(acc) => acc.accRefNumber === account.accRefNumber
							) || false
						}
					/>
				)}
			</ListItemIcon>
			<ListItemText
				primary={
					<List disablePadding>
						<ListItem
							sx={{
								m: '0.5rem 1.25rem 0 0',
								background: isDark ? '#3D3D3D' : theme.palette.primary.light,
								color: isDark ? '#FFFFFF' : '#000000',
								p: '0.5rem',
								borderRadius: '14px',
								border: 'none',
							}}
						>
							<ListItemIcon>
								<Avatar
									alt={''}
									src={global.objectFormatFip[fipId]?.productIconUri}
									sx={{
										...stylesLogo.avatarStyle,
										background: isDark
											? '#2D2D2D'
											: theme.palette.primary.light,
									}}
								/>
							</ListItemIcon>
							<ListItemText
								sx={{
									'& .MuiListItemText-primary': {
										color: isDark ? '#FFFFFF' : theme.palette.info.main,
										...sizeFontCustom.subHeading,
									},
									'& .MuiListItemText-secondary': {
										color: isDark ? '#7A8185' : theme.palette.black60,
										fontSize: '0.75rem',
									},
									borderRadius: '14px',
									m: 0,
								}}
								primary={capitalize(account.accType)}
								secondary={account.maskedAccNumber.replaceAll('X', '\u2022')}
							/>
							{(isLinked || isVerified?.includes(account.accRefNumber)) && (
								<Chip
									variant="outlined"
									label={
										<Typography
											sx={{
												...sizeFontCustom.subHeading,
												color: isDark ? '#FFFFFF' : '#000000',
											}}
										>
											{t('common.buttons.linked')}
										</Typography>
									}
									sx={{
										backgroundColor: isDark
											? '#2D2D2D'
											: theme.palette.primary.white,
										borderColor: isDark ? '#7A8185' : 'inherit',
										color: isDark ? '#FFFFFF' : '#000000',
									}}
									size="small"
									color={'success'}
								/>
							)}
						</ListItem>
					</List>
				}
			/>
		</ListItem>
	);
}

export default FipDiscoveredAccounts;
